/* Componente zoom Sardegna */
import React from 'react'
import {Component} from 'react'
import sardegnaImage from './sardegna.svg'

import { useEffect } from "react";
import { useLeaflet } from "react-leaflet";

import L, { divIcon } from "leaflet";


const ZoomSardegna =(props)=>{
        const { map } = useLeaflet();
        useEffect(() => {
            
          const legend = L.control({ position: "topright" });
          
          const div = L.DomUtil.create("button", "legend");
          
          div.style.width = (!props.value.buttonStyle)? "30px":props.value.buttonStyle.width
          div.style.height = (!props.value.buttonStyle)? "30px":props.value.buttonStyle.height
          div.style.backgroundColor = (!props.value.buttonStyle)? "white":props.value.buttonStyle.backgroundColor 
          div.style.opacity = (!props.value.buttonStyle)? 1:props.value.buttonStyle.opacity
          div.style.borderWidth = (!props.value.buttonStyle)? 0:props.value.buttonStyle.borderWidth
          div.style.borderRadius = (!props.value.buttonStyle)? "3px":props.value.buttonStyle.borderRadius
          div.style.boxShadow = (!props.value.buttonStyle)? "1px 1px 5px rgb(0 0 0 / 65%)":props.value.buttonStyle.boxShadow
          div.style.marginRight = "12px"

          var img = L.DomUtil.create('img', 'sardegna_icon', div);
          
          img.src = sardegnaImage
          div.setAttribute('type', 'button')
          div.setAttribute('id','zoom_sardegna')


          legend.onAdd = () => {
            return div;
          };

          L.DomEvent.on(div, 'click', function(e) {
            //const position = props.center //[40.061604, 9.097754]  //CENTRO SARDEGNA
            e.preventDefault()
            e.stopPropagation()
            //map.flyTo(position,8)
            if(props.center && props.zoom) map.setView(props.center, props.zoom);            
          });
          legend.addTo(map);
      
          return () => legend.remove();
        }, [map]);
        return null;
    
}
export default ZoomSardegna